import React, {useEffect, useState} from "react";
import '../assets/styles/components/home-filter-block.scss'
import {getPropsFromState} from "../redux/mapStateToProps";
import {GetAreasInfo, ResetAreasInfo} from "../redux/actions";
import {connect} from "react-redux";
import { useNavigate} from "react-router-dom";
import { AREA_TYPES,} from "../constants/constants";
import {ClearIcon} from "../assets/images";

import {InputGroup} from "./ui-elements/input-group/inputGroup";
import {PrimaryButton} from "./ui-elements/buttons/Buttons";
import {getUrlWithLocal} from "../utils/getUrlWithLocal";
import {CustomRangeSlider, RoomCounter} from "../components/filter/filter-components";


function HomeFilterBlock(props) {
    const {staticTexts, areaData, initialAreaData} = props
    const navigate = useNavigate();

    let MIN_PRICE = initialAreaData?.minPrice || 0;
    let MAX_PRICE = Math.ceil(initialAreaData?.maxPrice / 100000) * 100000 || 9999999;

    const filtersInitialValues = {
        type: undefined,
        roomsCount: [],
        minPrice: MIN_PRICE,
        maxPrice: MAX_PRICE,
    }

    const typesOptions = Object.values(AREA_TYPES).map(type => {
        return {
            id: type?.key,
            name: staticTexts?.[type?.title]
        }
    })

    //State
    const [filters, setFilters] = useState(filtersInitialValues)
    const [tempData, setTempData] = useState({
        minPrice: MIN_PRICE,
        maxPrice: MAX_PRICE,
    })
    //Hooks
    useEffect(() => {
        !!initialAreaData && props.ResetAreasInfo()
    }, [])

    useEffect(() => {
        setFilters(filtersInitialValues);
        setTempData({
            minPrice: MIN_PRICE,
            maxPrice: MAX_PRICE,
        })
    }, [initialAreaData?.minPrice])
    //Functions
    const onChangeSlider = (values) => {
        setTempData({
            ...tempData,
            minPrice: values[0],
            maxPrice: values[1],
        })
    }

    function onAfterChangePrice(values) {
        const state = {
            ...filters,
            minPrice: values[0] !== MIN_PRICE ? values[0] : MIN_PRICE,
            maxPrice: values[1] !== MAX_PRICE ? values[1] : MAX_PRICE
        }
        changeFilterState(state)
    }

    function changeFilter(name, value) {
        let state;
        if (name === "roomsCount") {
            state = {
                ...filters,
                [name]: filters?.roomsCount?.includes(value) ?
                    filters?.roomsCount?.filter(item => item !== value) :
                    [value, ...filters.roomsCount]
            }
        } else {
            state = {
                ...filters,
                [name]: value
            };
        }
        changeFilterState(state);
    }

    function changeFilterState(state) {
        setFilters(state);
        props.GetAreasInfo({
            ...state,
            MIN_PRICE,
            MAX_PRICE
        })
    }

    function removeFilters() {
        setFilters(filtersInitialValues);
        setTempData({
            minPrice: MIN_PRICE,
            maxPrice: MAX_PRICE,
        })
        props.ResetAreasInfo()
    }

    function checkIsFilterValueSelected () {
        let result = false;
        Object.keys(filtersInitialValues).forEach(key => {
            if(key === 'roomsCount'){
                if(filters?.roomsCount?.length){
                    result =true;
                }
                return;
            }
            if(filtersInitialValues[key] !== filters[key]){
                result =true;
            }
        })
        return result;
    }

    return <div className={'home-filter-block'}>
        <div className={'filters'}>
            <div className={'filter-top'}>
                <div className={'drop-down-item'}>
                    <div className={'block-title'}>{staticTexts?.filter_type_title || 'Տեսակ'}</div>
                    <InputGroup
                        showSearch={false}
                        inputType={'select'}
                        value={filters.type || undefined}
                        name={'type'}
                        onClear={staticTexts?.filter_drop_down_all}
                        placeholder={staticTexts?.filter_type_title || 'Ընտրել տեսակ'}
                        onChange={changeFilter}
                        options={typesOptions}/>
                </div>
                <div className={'filter-slider-range'}>
                    <CustomRangeSlider
                        title={staticTexts?.filter_price_title}
                        MIN_VALUE={MIN_PRICE}
                        MAX_VALUE={MAX_PRICE}
                        filter_from={staticTexts?.filter_from}
                        filter_to={staticTexts?.filter_to}
                        minValue={tempData.minPrice}
                        maxValue={tempData.maxPrice}
                        onChangeSlider={onChangeSlider}
                        onAfterChange={onAfterChangePrice}
                    />
                </div>
                <div className={'rooms-count-wrapper'}>
                    <RoomCounter staticTexts={staticTexts}
                                 activeRooms={filters?.roomsCount}
                                 changeFilter={changeFilter}
                                 disabled={filters?.type === AREA_TYPES.OFFICE.key}
                    />
                </div>
                <PrimaryButton className="filters-count-wrapper"
                               title={<><span className={'filters-number'}>{areaData?.count || 0} </span>
                                   <span className={'filters-count'}>{staticTexts?.filter_rooms_total}</span></>}
                               cb={() => {
                                   navigate(getUrlWithLocal('/filter'), {
                                       state: filters,
                                   })
                               }}
                >
                </PrimaryButton>
            </div>
            <div className={`filter-down ${checkIsFilterValueSelected() ? "show-remove-btn" : ''}`}>
                <button onClick={() => {
                    removeFilters()
                }}>{staticTexts?.filter_clear_filters} <ClearIcon title={''}/></button>
            </div>

        </div>
    </div>
}

const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'areaData',
    'initialAreaData',
]);

const mapDispatchToProps = {
    GetAreasInfo,
    ResetAreasInfo,

    // GetHouses,
    // ClearFilter,
    // FilterState,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeFilterBlock)
